import React from "react";
import { useTranslation } from "react-i18next";
import { MdTimeline } from "react-icons/md";
import ReusableModal from "../../../shared/ReuseableModal";
import PatientJourneyTimeline from "./PatientJourneyTimeline";

const PatientJourneyModal = ({
  visible,
  onClose,
  patientId,
  fileNumber,
  documentId,
  visitId,
}) => {
  const { t } = useTranslation();

  return (
    <ReusableModal
      position="top"
      isVisible={visible}
      onClose={onClose}
      title={t("Patient Journey")}
      HeaderIcon={MdTimeline}
      className="w-full md:w-[95vw] lg:w-[80vw]"
    >
      {visible && (
        <PatientJourneyTimeline
          patientId={patientId}
          fileNumber={fileNumber}
          documentId={documentId}
          visitId={visitId}
        />
      )}
    </ReusableModal>
  );
};

export default PatientJourneyModal;
